<script lang="ts">
	interface Props {
		className?: string;
		checked?: boolean;
	}

	let { className = '', checked = true }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
		{#if checked}
			<path
				d="M8.5 12.5L10.5 14.5L15.5 9.5"
				stroke="currentColor"
				stroke-width="1"
				stroke-linecap="round"
				stroke-linejoin="round"
			></path>
		{/if}
	</svg>
</div>
